import trans from "../../utils";

// Backend convention: 0 = Sunday ... 6 = Saturday
export const WEEK_DAYS = [
	{ value: 0, short: "Sun", full: "Sunday" },
	{ value: 1, short: "Mon", full: "Monday" },
	{ value: 2, short: "Tue", full: "Tuesday" },
	{ value: 3, short: "Wed", full: "Wednesday" },
	{ value: 4, short: "Thu", full: "Thursday" },
	{ value: 5, short: "Fri", full: "Friday" },
	{ value: 6, short: "Sat", full: "Saturday" },
];

export const normalizeDays = (daysOfWeek) => {
	if (!Array.isArray(daysOfWeek)) return [];
	return daysOfWeek
		.map((d) => Number(d))
		.filter((d) => Number.isInteger(d) && d >= 0 && d <= 6);
};

export const formatDaysSummary = (daysOfWeek) => {
	const days = normalizeDays(daysOfWeek);
	if (days.length === 7) return trans("Every day");
	return [...days]
		.sort((a, b) => a - b)
		.map((d) => trans(WEEK_DAYS[d].short))
		.join(", ");
};

/**
 * Compact, read-only visualization of a weekly schedule.
 * Selected days are rendered as filled brand-green dots.
 */
export default function WeekDayChips({ daysOfWeek, size = "small" }) {
	const days = normalizeDays(daysOfWeek);
	const dimension = size === "small" ? 24 : 36;
	const fontSize = size === "small" ? 10 : 12;

	return (
		<div style={{ display: "inline-flex", gap: 4 }}>
			{WEEK_DAYS.map((day) => {
				const active = days.includes(day.value);
				return (
					<span
						key={day.value}
						title={trans(day.full)}
						style={{
							width: dimension,
							height: dimension,
							borderRadius: "50%",
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize,
							fontWeight: 600,
							lineHeight: 1,
							userSelect: "none",
							color: active ? "#fff" : "#9aa3ae",
							backgroundColor: active ? "#0f6936" : "#f0f2f5",
							border: active ? "1px solid #0f6936" : "1px solid #e3e6ea",
						}}
					>
						{trans(day.short).charAt(0)}
					</span>
				);
			})}
		</div>
	);
}
